<template>
    <form v-on:submit.prevent="click" v-if="person">

        <div class="row">
            <div class="col-md-12">
                <!-- Custom Tabs -->
                <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                        <li class="active">
                            <a href="#tab_1" data-toggle="tab">Generali</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="tab_1">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="nome">Nome</label>
                                                <input type="text" class="form-control" id="nome"
                                                       name="nome"
                                                       v-model="person.nome" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="indirizzo">Indirizzo</label>
                                                <input type="text" class="form-control" id="indirizzo"
                                                       name="indirizzo"
                                                       v-model="person.indirizzo" :disabled="disabled">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="cap">Cap</label>
                                                <input type="text" class="form-control" id="cap"
                                                       name="cap"
                                                       v-model="person.cap" :disabled="disabled">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="provincia">Provincia</label>
                                                <input type="text" class="form-control" id="provincia"
                                                       name="provincia"
                                                       v-model="person.provincia" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="citta">Città</label>
                                                <input type="text" class="form-control" id="citta"
                                                       name="citta"
                                                       v-model="person.citta" :disabled="disabled">
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="nazionalita">Nazionalità</label>
                                                <input type="text" class="form-control" id="nazionalita"
                                                       name="nazionalita"
                                                       v-model="person.nazionalita" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="email">Email</label>
                                                <input type="text" class="form-control" id="email"
                                                       name="email"
                                                       v-model="person.email" :disabled="disabled">
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="telefono">Telefono</label>
                                                <input type="text" class="form-control" id="telefono"
                                                       name="telefono"
                                                       v-model="person.telefono" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="nascita_data">Data di nascita</label>
                                                <date-picker class="form-control" id="nascita_data"
                                                             name="nascita_data"
                                                             v-model="person.nascita_data" @dp-error="error"
                                                             :config="config"
                                                             :disabled="disabled"></date-picker>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="nascita_citta">Città di nascita</label>
                                                <input type="text" class="form-control" id="nascita_citta"
                                                       name="nascita_citta"
                                                       v-model="person.nascita_citta" :disabled="disabled">
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="nascita_nazione">Nazione di nascita</label>
                                                <input type="text" class="form-control" id="nascita_nazione"
                                                       name="nascita_nazione"
                                                       v-model="person.nascita_nazione" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- /.tab-pane -->
                        
                    </div>
                    <!-- /.tab-content -->

                    <div class="box-footer">
                        <div class="row">
                            <div class="col-md-2 col-md-offset-10">
                                <button class="btn btn-success btn-block" v-if="!disabled">
                                    <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                    Salva
                                </button>

                                <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                                        v-if="disabled">
                                    Attiva modifiche
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- nav-tabs-custom -->
            </div>
        </div>

    </form>
</template>

<script>
  import { clientDateFormat } from '../../filters'
  import personsApi from '../../api/persons'

  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker'

  // Import date picker css
  import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  export default {
    props: ['disabled', 'person', 'loader', 'showLabels'],
    methods: {
      click () {
        this.$emit('click', this.person)
      },
      error (e) {
        console.log(e)
      },
      activateMod () {
        this.$emit('activate-mod', this.person)
      }
    },
    data () {
      return {
        config: {
          format: clientDateFormat
        },
        persons: []
      }
    },
    computed: {
      donazione_tipi () {
        return this.$store.state.decoder.decoders['_dDonationTypes']
      }
    },
    beforeCreate () {
      personsApi.index()
        .then((response) => {
          this.persons = response.data.data
        })
    },
    components: {
      datePicker,
      Multiselect
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/persons/Form.vue